"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M16.07 11.19c-.03 0-.06.003-.09.004-.33-1.926-2.021-3.394-4.06-3.394a4.122 4.122 0 00-3.636 2.165C6.67 10.1 5.4 11.44 5.4 13.076c0 1.673 1.329 3.04 2.998 3.12v.004h7.672c1.398 0 2.53-1.121 2.53-2.505s-1.133-2.506-2.53-2.506zM12 15.175l-2.464-2.444h1.599V9.99c0-.228.187-.413.418-.413h.894c.23 0 .418.185.418.413v2.742h1.599L12 15.176z" }), "CloudSaved");
//# sourceMappingURL=CloudSaved.js.map